import React  from 'react';
import { X } from 'react-bootstrap-icons';
import classNames from 'classnames';
import Accordion from 'react-bootstrap/Accordion';

import { CategoryToggle } from './CategoryToggle';
import { Property } from './Property';

import { Filter } from '../../../Enum/Filters';
import { PropertiesByCategory } from '../../../Interface/Response/ProductProperty/List/PropertiesByCategory';

import useGetFilterValue from '../../../Hook/Interest/UseGetFilterValue';
import useGetToggledPropertyCategories from '../../../Hook/ProductProperties/UseGetToggledPropertyCategories';

interface Props {
    category: PropertiesByCategory;
    disabled: boolean;
    toggleProperty: (code: string) => void;
}

const PropertiesByCategoryMultiSelectFilter: React.FC<Props> = ({category, disabled, toggleProperty}) => {
    const propertiesInFilter = useGetFilterValue(Filter.MortgageProperties) as string[];
    const toggledCategories = useGetToggledPropertyCategories();

    return (
        <Accordion
            key={`category-${category.name}`}
            defaultActiveKey={!toggledCategories.includes(category.name)
                ? category.name
                : ''
            }>
            <CategoryToggle name={category.name} />
            <Accordion.Collapse eventKey={category.name}>
                <>
                    {category.properties.map(property => <p
                        key={property.code}
                        onClick={() => toggleProperty(property.code)}
                        onKeyDown={() => toggleProperty(property.code)}
                        className={classNames({
                            active: propertiesInFilter.includes(property.code),
                            disabled: !propertiesInFilter.includes(property.code) && disabled
                        })}
                    >
                        <Property name={property.name} />
                        {propertiesInFilter.includes(property.code) && <X />}
                    </p>)}
                </>
            </Accordion.Collapse>
        </Accordion>
    );
};

export default PropertiesByCategoryMultiSelectFilter;
